import EditAdtInfoTitleDialog from "./editAdtInfoTitleDialog.container";

export default EditAdtInfoTitleDialog;
